import { getLocalizedStrings } from "../centralizedLocalizedString";
import MultiAccountPreference from "./MultiAccountPreference";
import GlobalErrorCard from "./Presentational/GlobalErrorCard";
import styles from "./AccountPreference.scss";
import AccountPreferenceContainerHelper from "./AccountPreferenceContainerHelper";
class AccountPreferenceContainer extends React.Component {
  constructor(props) {
    super(props);
    this.strings = getLocalizedStrings("AccountPreference");
    this.state = {
      cpcData: {},accountDetails: [],preferenceDetails: [{papr: {email_id: [],},outg: {email_id: [],phoneNo: [], textNo: [],directMail:null },emrg: {email_id: [],phoneNo: [], textNo: [],},buda: {email_id: [],phoneNo: [], textNo: [],},cpp: {email_id: [],phoneNo: [],textNo: [],},},],
      errorCard: undefined,isWebUser: false,showError: false,showSearchError: false,searchtypeError:"",refreshPref: "",errorResponse: "",emailPref: "",isContractNull: false, Name: "", contractAccountSearchList:[],searchText:"",serachMode:false,searchType:"",loaderDialogBox: false, searchErrMsg:true,totalPages:0,lastCurrPage:1,paprRecord:{record:{}},
      bpNumber: "",isContractAccountExpanded: false,isContractResultExpanded: false,contractAccountNumber: "",contractNumber: "",isLoading: false,currentPage: 1,startPage:1,endPage:10,clickCount:0,isClicked:false,contractNumberCount: 0,viewShowMoreContracts: false,viewShowLessContracts: false,totalNoOfContractsOnScreen: 5,formattedDataForCpp:"",addressGuid:"",
      formattedDataForOutg:{email_id:[],phoneNo:[],textNo:[],directMail:null}, formattedDataForEmrg:{email_id:[],phoneNo:[],textNo:[]}, formattedDataForBuda:{email_id:[],phoneNo:[],textNo:[]}, baEnrollmentDetailsVO:null, dropDownData:'', onlyOneBpEnrolled: "",
      prefData:{}, depaprRecord:{record:[]}, ebillpaprRecord: {record:[]}, ebillpaprCount:"", ebillpaprSold:{record:[]}, ebillpaprAuth:{record:[]}
    };
    this.contractResultReqprms={};
    this.counter=0; // to track showMore click
    this.onPbToggleOnOffClick = AccountPreferenceContainerHelper.onPbToggleOnOffClick.bind(this);
  }

  componentWillMount() {
    this.setState({addressGuid:this.props.cpcData.customerDetails[0].addressGuid,cpcData: this.props.cpcData,Name: this.props.cpcData.bpName,bpNumber: this.props.cpcData.bpNumber,isWebUser: this.props.isWebUser,errorResponse: this.props.errorResponse,},
      () => {
        let cpcSearchContract = app.appService.getSessionstorage('cpcSearchContract');
        if(!_.isEmpty(cpcSearchContract)){
          this.filterSearchedCactList(cpcSearchContract.contractNumber,"contractNumber", "search",0);
        } else this.handle(); });}

  componentWillReceiveProps(nextProps) {
    if (this.props !== nextProps) {
        let endPage=((this.state.startPage + nextProps.cpcData.contractAccountResults.length)>this.state.totalPages)?this.state.totalPages : this.state.startPage + nextProps.cpcData.contractAccountResults.length-1;

        this.setState(
            {cpcData: nextProps.cpcData,Name: nextProps.cpcData.bpName,bpNumber: nextProps.cpcData.bpNumber,isWebUser: nextProps.isWebUser,errorResponse: nextProps.errorResponse,endPage: endPage,},
            () => {this.handle();});}}

  launchErrorModal = () => {
    if (this.state.errorResponse.length) {
      let maps = new Map(
        this.state.errorResponse.map((o) => [o.programDetails, o])
      );
      let programError = maps.get("CPC_PROGRAMS");
      if (!_.isEmpty(programError)) {
        return programError.errorFlag;
      } } };

  handle = () => {
    const updatedState = { ...this.state };
    if (updatedState.accountDetails !== null) updatedState.accountDetails = [];
    if (this.state.cpcData.contractAccountResults.length) {
      let filtered = this.state.serachMode?this.state.contractAccountSearchList.contractAccountResults : this.props.cpcData.contractAccountResults;
      filtered.map((cpcData) => {
        let temp = {};
        temp.Name = cpcData.bpName, temp.contractAccountNumber = cpcData.contractAccountNumber, temp.houseNumber = cpcData.houseNumber, temp.contractResults = cpcData.contractResults, temp.city = cpcData.city, temp.postBoxNumber = cpcData.postBoxNumber && cpcData.postBoxNumber!==''? cpcData.postBoxNumber: '' ,  temp.contractAccountStatus = cpcData.contractAccountStatus;
        temp.state = cpcData.state, temp.supplement = cpcData.unitNumber, temp.streetAddress = cpcData.contractAccountStreetAddress,temp.zipcode = cpcData.zipCode, temp.contractNumbercount = cpcData.contractNumbercount, temp.obEnrollmentFlag = cpcData.obEnrollmentFlag,temp.isEligible = cpcData.isEligible,temp.reason = cpcData.reason,temp.bpNumber = cpcData.bpNumber, temp.bpCategory = cpcData.bpCategory, temp.nextStatementDate = cpcData.nextStatementDate;
        updatedState.accountDetails.push(temp);
      });
      updatedState.totalPages = this.state.serachMode?this.state.contractAccountSearchList.contractAccountCount:this.state.cpcData.contractAccountCount;
      updatedState.loaderDialogBox = false;
      if(this.state.searchType === "contractAccountNumber" || this.state.searchType === "contractNumber")
      {updatedState.totalPages = 1;}
      } else {updatedState.isContractNull = true; }
      updatedState.dropDownData = app.appService.getSessionstorage('dropDownData');
      this.setState(updatedState, ()=>{
        let cpcSearchContract = app.appService.getSessionstorage('cpcSearchContract');
        if(!_.isEmpty(cpcSearchContract) && !updatedState.showSearchError) {
          app.appService.removeSessionStorageItem('cpcSearchContract');
          this.onContractAccountClick(updatedState.accountDetails[0].contractAccountNumber, false);
          this.onPbToggleOnOffClick(updatedState.accountDetails[0].bpNumber, updatedState.accountDetails[0].contractAccountNumber);
          this.onContractResultClick(updatedState.accountDetails[0].contractAccountNumber, cpcSearchContract.contractNumber, '', false, updatedState.accountDetails[0].bpNumber, updatedState.accountDetails[0].bpCategory);
        }
      });
    };

  setPreference(preferences, type, value) {
    const updatedState = { ...this.state };
    if(type==="directMail"){
      updatedState.preferenceDetails[0].outg.directMail = (preferences && preferences.record_guid) ? preferences : null;
      updatedState.formattedDataForOutg.directMail = (preferences && preferences.record_guid) ? preferences : null;}   else {
      preferences.map((preference) => {
        if (preference.category === "OUTG" && preference.messageType === "OUTG") {
          updatedState.preferenceDetails[0].outg[type].push(preference[value]);
          updatedState.formattedDataForOutg[type].push(preference);
         } else if (preference.category === "OUTG" && preference.messageType === "EMRG") {
          updatedState.preferenceDetails[0].emrg[type].push(preference[value]);
          updatedState.formattedDataForEmrg[type].push(preference);
        } else if (preference.category === "PROG" && preference.messageType === "BUDA") {
          updatedState.preferenceDetails[0].buda[type].push(preference[value]);
          updatedState.formattedDataForBuda[type].push(preference);
        } else if (preference.category === "DEMR" && preference.messageType === "CPP1") {
          updatedState.preferenceDetails[0].cpp[type].push(preference[value]);
        }
      });}
    this.setState(updatedState);
  }

  onContractAccountClick = (contractAccountNumber, isOpen) => {
    isOpen ? window.aUtils.sendAAEvent("aaccordion:Collapse"," contractAccount"+ contractAccountNumber) : window.aUtils.sendAAEvent("accordion:Expand"," contractAccount"+contractAccountNumber);
    let status = false;  
    if(isOpen) status = true;

    let updatedState = { ...this.state };
    updatedState.isContractAccountExpanded = true;
    let preferenceEmail = [];
     let paprRecord={record:{}}, depaprRecord={record:[]};
    updatedState.contractAccountNumber = contractAccountNumber;
    
    let catResults = this.state.serachMode?this.state.contractAccountSearchList.contractAccountResults:this.state.cpcData.contractAccountResults;
    let contractNumberCount = catResults.filter(data=>{
        if(data.contractAccountNumber === contractAccountNumber) 
          {return data.contractNumbercount;}
  });
    // to hide show more/less after clicking on accordian which has show more then clicked on another accordian.  
    contractNumberCount[0].contractNumbercount > 5 ? (updatedState.viewShowMoreContracts = true, updatedState.viewShowLessContracts = false, contractNumberCount[0].contractResults=contractNumberCount[0].contractResults.slice(0,5)):(updatedState.viewShowMoreContracts = false, updatedState.viewShowLessContracts = false);
    _.each(updatedState.accountDetails, function (record,index) {
        {record.contractResults=record.contractResults.slice(0,5);}
     });
   
    app.centralizedService.getContractAccountPref(contractNumberCount[0].bpNumber, contractAccountNumber, updatedState.isWebUser).then((response) => {
        if (response.errorCode !== undefined && response.errorCode !== "") {
          //to be completed
          this.setState({ errorCard: true, });
        } else {
          response.record.map((record) => {
          if (record.record_guid !== null){
            preferenceEmail.push(record.email_id);
            paprRecord.record=record;
            depaprRecord.record.push(record);
            }});
          updatedState.preferenceDetails[0].papr.email_id = preferenceEmail;
          this.setState({isContractAccountExpanded: !status,contractAccountNumber: contractAccountNumber,preferenceDetails: updatedState.preferenceDetails, contractNumberCount: contractNumberCount[0].contractNumbercount,viewShowMoreContracts: updatedState.viewShowMoreContracts, totalNoOfContractsOnScreen: 5,loaderDialogBox: false,paprRecord:paprRecord, prefData:response.record, depaprRecord:depaprRecord });}
      });
    this.setState({isContractAccountExpanded: !status,contractAccountNumber: contractAccountNumber,preferenceDetails: updatedState.preferenceDetails,contractNumberCount: contractNumberCount[0].contractNumbercount, viewShowMoreContracts: updatedState.viewShowMoreContracts, viewShowLessContracts:updatedState.viewShowLessContracts,totalNoOfContractsOnScreen: 5,loaderDialogBox: false,accountDetails:updatedState.accountDetails});};
  onContractResultClick = (contractAccountNumber, contractNumber, premiseNumber, isOpen, contractBpNumber, contractBpCategory) => {
    isOpen ? window.aUtils.sendAAEvent("aaccordion:Collapse"," contractNumber"+ contractNumber) : window.aUtils.sendAAEvent("accordion:Expand"," contractNumber"+ contractNumber);
    let status = false;
    if(isOpen)
    status = true;
    app.centralizedService.getContractPref(this.state.bpNumber, contractAccountNumber, contractNumber, premiseNumber,this.state.addressGuid,contractBpNumber, contractBpCategory).then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== "") {
          this.contractResultReqprms.contractAccountNumber=contractAccountNumber, this.contractResultReqprms.contractNumber=contractNumber,
          this.contractResultReqprms.premiseNumber=premiseNumber, this.contractResultReqprms.isOpen=isOpen,
          this.contractResultReqprms.contractBpNumber=contractBpNumber, this.contractResultReqprms.contractBpCategory=contractBpCategory;
          this.setState({loaderDialogBox: false,showError: true,preferenceContent: false,});}
          else {
          this.contractResultReqprms={};
          // ANC-395 : Except for papr, for all other products empty previous preference data and update with new data received from response.
          this.setState({showError:false,baEnrollmentDetailsVO:response.response.record.baEnrollmentDetailsVO,onlyOneBpEnrolled:response.response.record.onlyOneBpEnrolled, formattedDataForCpp:response.cpcFormatedData, formattedDataForOutg:{email_id:[],phoneNo:[],textNo:[],directMail:null}, formattedDataForEmrg:{email_id:[],phoneNo:[],textNo:[]}, formattedDataForBuda:{email_id:[],phoneNo:[],textNo:[]}, preferenceDetails: [{papr: {email_id: this.state.preferenceDetails[0].papr.email_id,},outg: {email_id: [],phoneNo: [], textNo: [], directMail:null, }, emrg: {email_id: [],phoneNo: [], textNo: [], }, buda: {email_id: [],phoneNo: [], textNo: [],},cpp: {email_id: [],phoneNo: [],textNo: [],},},]}, () => {
            this.setPreference(response.response.record.emailPreferences, "email_id","email_id"), this.setPreference(response.response.record.phonePreferences, "phoneNo","maskedPhoneNumber"),
            this.setPreference(response.response.record.textPreferences, "textNo","maskedText"), this.setPreference(response.response.record.directMailLetterPreference,"directMail");
          });
        }
      });
    this.setState({isContractResultExpanded: !status, contractNumber: contractNumber,loaderDialogBox: false });
  };
  handlePageChange = (selectedPageNumber) => {
    window.aUtils.sendAAEvent("link","contractAccountPagination");
    let updatedState = { ...this.state };
    updatedState.currentPage = selectedPageNumber, updatedState.loaderDialogBox = true;
    window.scrollTo(0, 0);
    let offsetValue = selectedPageNumber * 10;
    let offset = selectedPageNumber === 1 ? 0 : offsetValue - 10;
    updatedState.startPage = selectedPageNumber !== 1? offset+1: 1;
    this.setState(updatedState);
    this.state.serachMode? this.filterSearchedCactList(updatedState.searchText,updatedState.searchType, "search",offset):
    this.props.isWebUser
    ? this.props.getWebUserDetails(offset)
    : this.props.getMyAccountDetails(offset);};

    handleShowMore = (contractAccountNumber) => {
      let updatedState = { ...this.state };
      this.setState({ loaderDialogBox: true });
      let totalNoOfContractsOnScreen;
      
      //ANC-802 passing coOffset value 10 and mutiplies of 5 for contractNumberCount greater than 10  and second show more click.
      if(this.state.contractNumberCount>10 && this.counter>0){
        totalNoOfContractsOnScreen = this.state.totalNoOfContractsOnScreen+5; 
      }
      //ANC-783 passing coOffset value 5 for contractAnumberCount less than 10.
      else{
        totalNoOfContractsOnScreen = this.state.totalNoOfContractsOnScreen;
      }
      updatedState.isLoading = false;
      updatedState.totalNoOfContractsOnScreen = totalNoOfContractsOnScreen;
      
      if(this.state.totalNoOfContractsOnScreen < this.state.contractNumberCount)
      {
          if(totalNoOfContractsOnScreen >= this.state.contractNumberCount || (this.state.contractNumberCount <=10 && this.state.contractNumberCount>5) || ((this.state.contractNumberCount-totalNoOfContractsOnScreen) <=5) )
          {
            updatedState.viewShowMoreContracts = false, updatedState.viewShowLessContracts = true;
          }
          app.centralizedService.getHandleSearch("contractAccountNumber",contractAccountNumber,10,0,5,totalNoOfContractsOnScreen)
          .then((response) => {
          if (response.errorCode !== undefined && response.errorCode !== "") {
            //to be completed
            this.setState({
              loaderDialogBox: false,
              errorCard: true,
            });
          } else {
            let contractResults = response.bpRecords[0].contractAccountResults[0].contractResults;
            updatedState.accountDetails.map(accountDetails=>{
                if(accountDetails.contractAccountNumber === contractAccountNumber)
                { accountDetails.contractResults=accountDetails.contractResults.concat(contractResults);}
            });
            this.setState({
              totalNoOfContractsOnScreen: totalNoOfContractsOnScreen, accountDetails: updatedState.accountDetails,viewShowMoreContracts: updatedState.viewShowMoreContracts,viewShowLessContracts: updatedState.viewShowLessContracts, loaderDialogBox: false,
            });
            this.counter++;
          }
        });
      }
      else{
          updatedState.viewShowMoreContracts = false, updatedState.viewShowLessContracts = true;
          this.setState({ viewShowMoreContracts: updatedState.viewShowMoreContracts,viewShowLessContracts: updatedState.viewShowLessContracts,loaderDialogBox: false,
          });
      }
      
    };
  
    handleShowLess=(contractAccountNumber)=>{
      let updatedState = {...this.state};
      updatedState.totalNoOfContractsOnScreen = 5, updatedState.viewShowMoreContracts = true, updatedState.viewShowLessContracts = false, this.counter=0;
      updatedState.accountDetails.map(accountDetails=>{
          if(accountDetails.contractAccountNumber === contractAccountNumber)
          {accountDetails.contractResults=accountDetails.contractResults.slice(0,5);}
      });
      this.setState(updatedState);
    };
  
    filterSearchedCactList = (searchText,searchType, action,offset) => {
      let updatedState = {...this.state};
      offset === 0 && action !== 'clear'? updatedState.lastCurrPage = this.state.currentPage: null;
      this.setState({ loaderDialogBox: true, lastCurrPage:updatedState.lastCurrPage});
      updatedState.showSearchError = false;
      updatedState.searchErrMsg = true;
      if(searchType === 'zipErr') 
          {updatedState.searchErrMsg = false;}
      if(searchType==="city")
      {updatedState.searchtypeError=this.strings.cityError;}
      else if(searchType===""||searchType==="contractNumber"||searchType==="contractAccountNumber")
      {updatedState.searchtypeError= this.strings.accountError;}
      else if(searchType==="zip")
      {updatedState.searchtypeError= this.strings.zipError;}
      else if(searchType==="streetName")
      {updatedState.searchtypeError= this.strings.streetnameError;}
      else if(searchType==="streetNumber")
      {updatedState.searchtypeError= this.strings.streetnumError;}
      if(action === 'clear'){
        updatedState.searchText = '';
        updatedState.searchType = '';
        updatedState.serachMode = false;
        updatedState.currentPage = this.state.lastCurrPage;
        updatedState.loaderDialogBox = false;
        this.setState(updatedState,()=>{
          this.handle();
      });
      }
      else if(searchText!=="" && action !== 'error'){
      app.centralizedService.getHandleSearch(searchType, searchText,10,offset,5,0,this.state.bpNumber).then( response=> {
        
       if (response.errorCode!=='' && response.errorCode !== undefined ) {
          updatedState.showSearchError = true;
          updatedState.loaderDialogBox = false;
          this.setState(updatedState);
        } else {
          updatedState.contractAccountSearchList = response.bpRecords[0];
          updatedState.currentPage = 1, updatedState.searchText = searchText, updatedState.searchType = searchType, updatedState.serachMode = true, updatedState.loaderDialogBox = false;
          updatedState.showSearchError = (updatedState.contractAccountSearchList.contractAccountCount === 0);
          this.setState(updatedState,()=>{
              this.handle();
          });
      }
      });}
      else{
          updatedState.showSearchError = true;
          updatedState.loaderDialogBox = false;
        this.setState(updatedState); }
    }
    getToNoAccountsView=()=>{
      return(
      <div> <div className={styles.ConHeading}>{this.strings.AccountPreferenceLabel}</div>
        <div className={styles.NoActView}> {this.strings.NoAccountMsge1}<br /><br />{this.strings.NoAccountMsge2}<a className={styles.LearnMore} href="/mysce/verifypin">{this.strings.LearnMore}</a>
          </div> </div> );}
    
    removePreference = (prefrenceType, formattedPreferenceType)=>{
      let updatedState = {...this.state};
      updatedState.preferenceDetails[0][prefrenceType] = (formattedPreferenceType === 'formattedDataForOutg' ? {email_id: [],phoneNo: [],textNo: [],directMail:null} : {email_id: [],phoneNo: [],textNo: []});
      formattedPreferenceType === 'formattedDataForCpp' ? updatedState[formattedPreferenceType] = {addressGuid: "", assignedStatusArray: [], emailSet: [], mobileSet: [], phoneSet: []} : updatedState[formattedPreferenceType] = {email_id:[],phoneNo:[],textNo:[]};
      if(formattedPreferenceType === 'formattedDataForOutg') updatedState[formattedPreferenceType] =  {email_id: [],phoneNo: [],textNo: [],directMail: null};
      this.setState(updatedState);
    }

    updateDropDownData = (dropDownData) => {
      app.appService.setSessionstorage('dropDownData',dropDownData);
      this.setState({dropDownData: app.appService.getSessionstorage('dropDownData')}); }

  render() {
    return (
      <div>
          {(this.state.showError)?<div>
        <div className={styles.ConHeading}>{this.strings.AccountPreferenceLabel}</div>
        <GlobalErrorCard message={this.strings.errMsg} subMessage={this.strings.errSubMsg} contractResultReqprms={this.contractResultReqprms} refreshPage={this.onContractResultClick} /></div>:
        <div>{(this.state.isContractNull && this.props.isWebUser)?<div>{this.getToNoAccountsView()}</div> :
        <MultiAccountPreference
          accountDetails={this.state.accountDetails} preferenceDetails={this.state.preferenceDetails} dropDownData={this.state.dropDownData} 
          isMultiAcc={1} onContractAccountClick={this.onContractAccountClick} updateDropDownData={this.updateDropDownData}
          isContractAccountExpanded={this.state.isContractAccountExpanded} contractAccountNumber={this.state.contractAccountNumber}
          handlePageChange={this.handlePageChange.bind(this)} currentPage={this.state.currentPage} startPage={this.state.startPage} endPage={this.state.endPage} cpcData={this.props.cpcData} customerData={this.props.customerData} onContractResultClick={this.onContractResultClick}
          isContractResultExpanded={this.state.isContractResultExpanded} contractNumber={this.state.contractNumber}
          handleShowMore={this.handleShowMore} handleShowLess={this.handleShowLess}viewShowMoreContracts={this.state.viewShowMoreContracts} viewShowLessContracts={this.state.viewShowLessContracts}
          filterSearchedCactList={this.filterSearchedCactList} showSearchError={this.state.showSearchError} searchText={this.state.searchText} searchType={this.state.searchType}
          searchErrMsg={this.state.searchErrMsg} removePreference={this.removePreference} searchtypeError={this.state.searchtypeError}
          totalPages={this.state.totalPages} isWebUser={this.state.isWebUser} staticContent={this.props.staticContent}
          formattedDataForCpp={this.state.formattedDataForCpp} getMyAccountDetails={this.props.getMyAccountDetails} getWebUserDetails={this.props.getWebUserDetails} paprRecord={this.state.paprRecord}
          formattedDataForOutg={this.state.formattedDataForOutg} formattedDataForEmrg={this.state.formattedDataForEmrg} formattedDataForBuda={this.state.formattedDataForBuda} baEnrollmentDetailsVO={this.state.baEnrollmentDetailsVO} onlyOneBpEnrolled={this.state.onlyOneBpEnrolled}
          onPbToggleOnOffClick={this.onPbToggleOnOffClick} ebillpaprRecord={this.state.ebillpaprRecord} ebillpaprSold={this.state.ebillpaprSold} ebillpaprAuth={this.state.ebillpaprAuth} ebillpaprCount={this.state.ebillpaprCount} prefData={this.state.prefData} depaprRecord={this.state.depaprRecord} billingRateType={this.props.billingRateType}
          />}</div>}
      </div>
    );
  }
}
export default AccountPreferenceContainer;
